import { render } from "./OpenMenuLogo.vue?vue&type=template&id=0388203a"
import script from "./OpenMenuLogo.vue?vue&type=script&lang=js"
export * from "./OpenMenuLogo.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__